import React, { FC, useState } from "react";

interface VideoWithFallbackProps {
    videoSrc: string;
    fallbackSrc: string;
    alt?: string;
    className?: string;
    videoClassName?: string;
    imageClassName?: string;
    style?: React.CSSProperties;
    autoPlay?: boolean;
    loop?: boolean;
    muted?: boolean;
    playsInline?: boolean;
    preload?: "none" | "metadata" | "auto";
}

const VideoWithFallback: FC<VideoWithFallbackProps> = ({
    videoSrc,
    fallbackSrc,
    alt = "Background",
    className = "",
    videoClassName = "w-100 h-100",
    imageClassName = "w-100 h-100",
    style,
    autoPlay = true,
    loop = true,
    muted = true,
    playsInline = true,
    preload = "auto",
}) => {
    const [videoLoaded, setVideoLoaded] = useState(false);

    return (
        <div className={`position-relative overflow-hidden h-100 w-100 ${className}`}>
            {!videoLoaded && fallbackSrc && (
                <img
                    src={fallbackSrc}
                    alt={alt}
                    className={imageClassName}
                    style={{
                        objectFit: "cover",
                        ...style,
                    }}
                />
            )}

            <video
                src={videoSrc}
                autoPlay={autoPlay}
                loop={loop}
                muted={muted}
                playsInline={playsInline}
                preload={preload}
                className={videoClassName}
                style={{
                    objectFit: "cover",
                    opacity: videoLoaded ? 1 : 0,
                    transition: "opacity 0.4s ease-in-out",
                    ...style,
                }}
                onLoadedData={() => setVideoLoaded(true)}
                onCanPlay={() => setVideoLoaded(true)}
                onError={() => setVideoLoaded(false)}
            />
        </div>
    );
};

export default VideoWithFallback;